export default __webpack_public_path__ + "static/media/fasting_happened@3x.d4a604a1.jpg";